import "jquery";
import "jquery-ui";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
// import "popper";
import "../rails-links";
import "../utils/utm-tags-handlers.js"


//
import "./utils/assetPath.js";
import "./utils/cookies.js";
import "./utils/geoLocation.js";
import "./utils/validation.js";
import "./utils/promoText.js";
// import "./components/passwordProtection.js";
import "./data/countryCodes.js";
import "./components/regionSelector.js";
import "./components/accordion.js";
import "./components/phoneFlagSelector.js";
import "./components/campusSlider.js";
import "./components/heroSlider.js";
import "./components/reviewsSlider.js";
import "./components/newsSlider.js";
import "./components/teachersSlider.js";
import "./components/advantagesSlider.js";
import "./components/priceSlider.js";
import "./forms/downloadBrochureForm.js";
import "./translation/translations.js";
import "./translation/translateDate.js";
import "./translation/translatePage.js";
import "./translation/languageSwitcher.js";
import "./script.js";

window.addEventListener("load", function () {
  polyfillCountryFlagEmojis();
});
